import React from 'react'
import { Skeleton, Grid } from '@mui/material';

export const HomeSkeleton = () => {

    const array = [1, 2, 3, 4, 5, 6, 7, 8, 9];

    return (
        <>
            {array.map((num) =>
                <Grid item xs={12} sm={4} lg={4} key={num}>
                    <Skeleton variant='rectangular' width={360} height={170} animation="wave" />
                </Grid>
            )}
        </>
    )
}